// Generated by Melange

import * as Caml_obj from "melange.js/caml_obj.js";
import * as Curry from "melange.js/curry.js";
import * as Mapre_chat__Chat_projection from "../../shared/chat/chat_projection.js";
import * as Mapre_core__Access from "../../shared/core/access.js";
import * as Mapre_web__Web_accounts_model from "./web_accounts_model.js";
import * as Mapre_web__Web_attachments_model from "./web_attachments_model.js";
import * as Mapre_web__Web_build_model from "./web_build_model.js";
import * as Mapre_web__Web_checkpoint_model from "./web_checkpoint_model.js";
import * as Mapre_web__Web_comments_model from "./web_comments_model.js";
import * as Mapre_web__Web_environment_model from "./web_environment_model.js";
import * as Mapre_web__Web_graph_model from "./web_graph_model.js";
import * as Mapre_web__Web_invitation_model from "./web_invitation_model.js";
import * as Mapre_web__Web_message_model from "./web_message_model.js";
import * as Mapre_web__Web_permissions_model from "./web_permissions_model.js";
import * as Mapre_web__Web_personal_tokens_model from "./web_personal_tokens_model.js";
import * as Mapre_web__Web_project_model from "./web_project_model.js";
import * as Mapre_web__Web_publication_model from "./web_publication_model.js";
import * as Mapre_web__Web_pulls_model from "./web_pulls_model.js";
import * as Mapre_web__Web_session_tree from "./web_session_tree.js";
import * as Mapre_web__Web_session_usage_model from "./web_session_usage_model.js";
import * as Mapre_web__Web_settings_model from "./web_settings_model.js";
import * as Mapre_web__Web_subscription from "./web_subscription.js";
import * as Mapre_web__Web_timeline from "./web_timeline.js";
import * as Mapre_web__Web_types from "./web_types.js";
import * as Mapre_web__Web_usage_model from "./web_usage_model.js";
import * as Stdlib from "melange/stdlib.js";
import * as Stdlib__Int from "melange/int.js";
import * as Stdlib__List from "melange/list.js";
import * as Stdlib__Map from "melange/map.js";
import * as Stdlib__Option from "melange/option.js";
import * as Stdlib__String from "melange/string.js";

const initial_collapsed_sessions = Mapre_web__Web_session_tree.Ids.empty;

const initial_backlog = {
  before: undefined,
  more: false,
  loading: false,
  expanded: false
};

const initial_expanded_groups = Mapre_web__Web_timeline.Ints.empty;

const initial_collapsed_groups = Mapre_web__Web_timeline.Ints.empty;

const initial = {
  route: /* Home */ 0,
  workspaces: /* [] */ 0,
  projects: /* [] */ 0,
  sessions: /* [] */ 0,
  collapsed_sessions: initial_collapsed_sessions,
  templates: /* [] */ 0,
  subscriptions: /* [] */ 0,
  subscription_cursor: undefined,
  subscriptions_loading: false,
  selected: undefined,
  events: /* [] */ 0,
  cursor: 0,
  backlog: initial_backlog,
  commands: /* [] */ 0,
  permissions: Mapre_web__Web_permissions_model.initial,
  messages: Mapre_web__Web_message_model.initial,
  publication: Mapre_web__Web_publication_model.initial,
  checkpoint: Mapre_web__Web_checkpoint_model.initial,
  comments: Mapre_web__Web_comments_model.initial,
  form: undefined,
  workspace_form: undefined,
  project_form: undefined,
  environment_form: undefined,
  build_form: undefined,
  pulls_form: undefined,
  graph_form: undefined,
  settings_form: undefined,
  usage_form: undefined,
  session_usage: Mapre_web__Web_session_usage_model.initial,
  personal_tokens: undefined,
  account_form: undefined,
  invitation_form: undefined,
  notice: "",
  connection: "Connecting",
  entry: /* Loading */ 0,
  next_session: undefined,
  compact: false,
  navigation_open: false,
  github_login: false,
  current_user: undefined,
  session_query: "",
  sidebar_search_open: false,
  sidebar_collapsed: false,
  open_menu: undefined,
  session_panel: undefined,
  expanded_groups: initial_expanded_groups,
  collapsed_groups: initial_collapsed_groups
};

function locked(t) {
  return Caml_obj.caml_notequal(t.entry, /* Ready */ 1);
}

const Events_by_seq = Stdlib__Map.Make({
  compare: Stdlib__Int.compare
});

function merge(old, incoming) {
  const add = function (map, $$event) {
    const previous = Curry._2(Events_by_seq.find_opt, $$event.seq, map);
    if (previous !== undefined && previous.revision > $$event.revision) {
      return map;
    } else {
      return Curry._3(Events_by_seq.add, $$event.seq, $$event, map);
    }
  };
  const map = Stdlib__List.fold_left(add, Stdlib__List.fold_left(add, Events_by_seq.empty, old), incoming);
  return Stdlib__List.map((function (prim) {
    return prim[1];
  }), Curry._1(Events_by_seq.bindings, map));
}

function update_form(t, f) {
  const newrecord = Caml_obj.caml_obj_dup(t);
  newrecord.form = Stdlib__Option.map(f, t.form);
  return newrecord;
}

function update_workspace(t, f) {
  const newrecord = Caml_obj.caml_obj_dup(t);
  newrecord.workspace_form = Stdlib__Option.map(f, t.workspace_form);
  return newrecord;
}

function update_forms(t, action) {
  if (/* tag */ typeof action !== "object" && typeof action !== "function") {
    switch (action) {
      case /* Close_form */ 3 :
        const newrecord = Caml_obj.caml_obj_dup(t);
        newrecord.notice = "";
        newrecord.form = undefined;
        return newrecord;
      case /* Pending */ 5 :
        return update_form(t, (function (f) {
          return {
            source: f.source,
            subscription: f.subscription,
            title: f.title,
            prompt: f.prompt,
            attachments: f.attachments,
            budget: f.budget,
            deadline: f.deadline,
            request_id: f.request_id,
            pending: true
          };
        }));
      case /* Close_workspace */ 10 :
        const newrecord$1 = Caml_obj.caml_obj_dup(t);
        newrecord$1.notice = "";
        newrecord$1.workspace_form = undefined;
        return newrecord$1;
      case /* Workspace_pending */ 12 :
        return update_workspace(t, (function (f) {
          return {
            name: f.name,
            timezone: f.timezone,
            request_id: f.request_id,
            pending: true
          };
        }));
      default:
        return t;
    }
  } else {
    switch (action.TAG) {
      case /* Choose_subscription */ 6 :
        const subscription = action._0;
        return update_form(t, (function (f) {
          if (f.pending) {
            return f;
          } else {
            return {
              source: f.source,
              subscription: subscription,
              title: f.title,
              prompt: f.prompt,
              attachments: f.attachments,
              budget: f.budget,
              deadline: f.deadline,
              request_id: f.request_id,
              pending: f.pending
            };
          }
        }));
      case /* Open_form */ 15 :
        let request_id = action._0;
        const newrecord$2 = Caml_obj.caml_obj_dup(t);
        newrecord$2.notice = "";
        newrecord$2.form = {
          source: undefined,
          subscription: undefined,
          title: "",
          prompt: "",
          attachments: Mapre_web__Web_attachments_model.initial,
          budget: "1.00",
          deadline: "",
          request_id,
          pending: false
        };
        return newrecord$2;
      case /* Open_child */ 16 :
        const parent = action._1;
        const snapshot = action._0;
        const t$1 = update_forms(t, {
          TAG: /* Open_form */ 15,
          _0: action._2
        });
        return update_form(t$1, (function (f) {
          return {
            source: [
              snapshot,
              parent
            ],
            subscription: f.subscription,
            title: f.title,
            prompt: f.prompt,
            attachments: f.attachments,
            budget: f.budget,
            deadline: f.deadline,
            request_id: f.request_id,
            pending: f.pending
          };
        }));
      case /* Title */ 17 :
        const title = action._0;
        return update_form(t, (function (f) {
          return {
            source: f.source,
            subscription: f.subscription,
            title,
            prompt: f.prompt,
            attachments: f.attachments,
            budget: f.budget,
            deadline: f.deadline,
            request_id: f.request_id,
            pending: f.pending
          };
        }));
      case /* Prompt */ 18 :
        const prompt = action._0;
        return update_form(t, (function (f) {
          return {
            source: f.source,
            subscription: f.subscription,
            title: f.title,
            prompt,
            attachments: f.attachments,
            budget: f.budget,
            deadline: f.deadline,
            request_id: f.request_id,
            pending: f.pending
          };
        }));
      case /* Budget */ 19 :
        const budget = action._0;
        return update_form(t, (function (f) {
          return {
            source: f.source,
            subscription: f.subscription,
            title: f.title,
            prompt: f.prompt,
            attachments: f.attachments,
            budget,
            deadline: f.deadline,
            request_id: f.request_id,
            pending: f.pending
          };
        }));
      case /* Deadline */ 20 :
        const deadline = action._0;
        return update_form(t, (function (f) {
          return {
            source: f.source,
            subscription: f.subscription,
            title: f.title,
            prompt: f.prompt,
            attachments: f.attachments,
            budget: f.budget,
            deadline,
            request_id: f.request_id,
            pending: f.pending
          };
        }));
      case /* Notice */ 21 :
        let notice = action._0;
        const entry = Caml_obj.caml_equal(t.entry, /* Loading */ 0) ? /* Load_failed */ 2 : t.entry;
        const newrecord$3 = Caml_obj.caml_obj_dup(t);
        const t$2 = update_form((newrecord$3.entry = entry, newrecord$3.notice = notice, newrecord$3), (function (f) {
          return {
            source: f.source,
            subscription: f.subscription,
            title: f.title,
            prompt: f.prompt,
            attachments: f.attachments,
            budget: f.budget,
            deadline: f.deadline,
            request_id: f.request_id,
            pending: false
          };
        }));
        return update_workspace(t$2, (function (f) {
          return {
            name: f.name,
            timezone: f.timezone,
            request_id: f.request_id,
            pending: false
          };
        }));
      case /* Open_workspace */ 29 :
        const newrecord$4 = Caml_obj.caml_obj_dup(t);
        newrecord$4.notice = "";
        newrecord$4.workspace_form = {
          name: "",
          timezone: "Asia/Shanghai",
          request_id: action._0,
          pending: false
        };
        return newrecord$4;
      case /* Workspace_name */ 30 :
        const name = action._0;
        return update_workspace(t, (function (f) {
          return {
            name,
            timezone: f.timezone,
            request_id: f.request_id,
            pending: f.pending
          };
        }));
      case /* Workspace_timezone */ 31 :
        const timezone = action._0;
        return update_workspace(t, (function (f) {
          return {
            name: f.name,
            timezone,
            request_id: f.request_id,
            pending: f.pending
          };
        }));
      case /* Project_setup */ 32 :
        let request_id$1 = action._0;
        if (/* tag */ typeof request_id$1 !== "object" && typeof request_id$1 !== "function") {
          switch (request_id$1) {
            case /* Close */ 0 :
              const newrecord$5 = Caml_obj.caml_obj_dup(t);
              newrecord$5.notice = "";
              newrecord$5.project_form = undefined;
              return newrecord$5;
            case /* Loading */ 6 :
              const newrecord$6 = Caml_obj.caml_obj_dup(t);
              newrecord$6.notice = "";
              newrecord$6.project_form = Stdlib__Option.map((function (p) {
                return Mapre_web__Web_project_model.update(p, /* Loading */ 6);
              }), t.project_form);
              return newrecord$6;
          }
        } else {
          switch (request_id$1.TAG) {
            case /* Open */ 0 :
              const newrecord$7 = Caml_obj.caml_obj_dup(t);
              newrecord$7.notice = "";
              newrecord$7.project_form = Mapre_web__Web_project_model.initial(request_id$1._0);
              return newrecord$7;
            case /* Rebind */ 1 :
              const p = Stdlib__List.find_opt((function (p) {
                return Caml_obj.caml_equal(p.id, Mapre_web__Web_types.project(t.route));
              }), t.projects);
              if (p === undefined) {
                return t;
              }
              const newrecord$8 = Caml_obj.caml_obj_dup(t);
              newrecord$8.notice = "";
              newrecord$8.project_form = Mapre_web__Web_project_model.for_project(request_id$1._0, p.id, p.version, p.base_branch);
              return newrecord$8;
          }
        }
        const newrecord$9 = Caml_obj.caml_obj_dup(t);
        newrecord$9.project_form = Stdlib__Option.map((function (p) {
          return Mapre_web__Web_project_model.update(p, request_id$1);
        }), t.project_form);
        return newrecord$9;
      case /* Environment */ 33 :
        let action$1 = action._0;
        if (/* tag */ typeof action$1 !== "object" && typeof action$1 !== "function") {
          if (action$1 === /* Close */ 0) {
            const newrecord$10 = Caml_obj.caml_obj_dup(t);
            newrecord$10.environment_form = undefined;
            return newrecord$10;
          }
          
        } else if (action$1.TAG === /* Open */ 0) {
          const newrecord$11 = Caml_obj.caml_obj_dup(t);
          newrecord$11.environment_form = Mapre_web__Web_environment_model.initial(action$1._0);
          return newrecord$11;
        }
        const newrecord$12 = Caml_obj.caml_obj_dup(t);
        newrecord$12.environment_form = Stdlib__Option.map((function (form) {
          return Mapre_web__Web_environment_model.update(form, action$1);
        }), t.environment_form);
        if (/* tag */ typeof action$1 !== "object" && typeof action$1 !== "function") {
          return newrecord$12;
        }
        if (action$1.TAG !== /* Saved */ 6) {
          return newrecord$12;
        }
        const receipt = action$1._0;
        const newrecord$13 = Caml_obj.caml_obj_dup(newrecord$12);
        newrecord$13.templates = /* [] */ 0;
        newrecord$13.projects = Stdlib__List.map((function (p) {
          if (Caml_obj.caml_equal(p.id, Mapre_web__Web_types.project(newrecord$12.route))) {
            return {
              id: p.id,
              name: p.name,
              repository: p.repository,
              version: receipt.project_version,
              base_branch: p.base_branch
            };
          } else {
            return p;
          }
        }), newrecord$12.projects);
        return newrecord$13;
      case /* Build */ 34 :
        let request_id$2 = action._0;
        if (/* tag */ typeof request_id$2 !== "object" && typeof request_id$2 !== "function") {
          if (request_id$2 === /* Close */ 0) {
            const newrecord$14 = Caml_obj.caml_obj_dup(t);
            newrecord$14.build_form = undefined;
            return newrecord$14;
          }
          
        } else if (request_id$2.TAG === /* Open */ 0) {
          const newrecord$15 = Caml_obj.caml_obj_dup(t);
          newrecord$15.build_form = Mapre_web__Web_build_model.initial(request_id$2._0);
          return newrecord$15;
        }
        const newrecord$16 = Caml_obj.caml_obj_dup(t);
        newrecord$16.build_form = Stdlib__Option.map((function (p) {
          return Mapre_web__Web_build_model.update(p, request_id$2);
        }), t.build_form);
        return newrecord$16;
      case /* Pulls */ 35 :
        let id = action._0;
        if (/* tag */ typeof id !== "object" && typeof id !== "function") {
          if (id === /* Close */ 0) {
            const newrecord$17 = Caml_obj.caml_obj_dup(t);
            newrecord$17.pulls_form = undefined;
            return newrecord$17;
          }
          
        } else if (id.TAG === /* Open */ 0) {
          const newrecord$18 = Caml_obj.caml_obj_dup(t);
          newrecord$18.notice = "";
          newrecord$18.pulls_form = Mapre_web__Web_pulls_model.initial(id._0);
          return newrecord$18;
        }
        const newrecord$19 = Caml_obj.caml_obj_dup(t);
        newrecord$19.pulls_form = Stdlib__Option.map((function (form) {
          return Mapre_web__Web_pulls_model.update(form, id);
        }), t.pulls_form);
        return newrecord$19;
      case /* Graph */ 36 :
        let request_id$3 = action._0;
        if (/* tag */ typeof request_id$3 !== "object" && typeof request_id$3 !== "function") {
          if (request_id$3 === /* Close */ 0) {
            const newrecord$20 = Caml_obj.caml_obj_dup(t);
            newrecord$20.graph_form = undefined;
            return newrecord$20;
          }
          
        } else if (request_id$3.TAG === /* Open */ 0) {
          const newrecord$21 = Caml_obj.caml_obj_dup(t);
          newrecord$21.graph_form = Mapre_web__Web_graph_model.initial(request_id$3._0);
          return newrecord$21;
        }
        const newrecord$22 = Caml_obj.caml_obj_dup(t);
        newrecord$22.graph_form = Stdlib__Option.map((function (p) {
          return Mapre_web__Web_graph_model.update(p, request_id$3);
        }), t.graph_form);
        return newrecord$22;
      case /* Settings */ 37 :
        let request_id$4 = action._0;
        if (/* tag */ typeof request_id$4 !== "object" && typeof request_id$4 !== "function") {
          if (request_id$4 === /* Close */ 0) {
            const newrecord$23 = Caml_obj.caml_obj_dup(t);
            newrecord$23.personal_tokens = undefined;
            newrecord$23.settings_form = undefined;
            return newrecord$23;
          }
          
        } else if (request_id$4.TAG === /* Open */ 0) {
          const newrecord$24 = Caml_obj.caml_obj_dup(t);
          newrecord$24.settings_form = Mapre_web__Web_settings_model.initial(request_id$4._0);
          return newrecord$24;
        }
        const newrecord$25 = Caml_obj.caml_obj_dup(t);
        newrecord$25.settings_form = Stdlib__Option.map((function (p) {
          return Mapre_web__Web_settings_model.update(p, request_id$4);
        }), t.settings_form);
        return newrecord$25;
      case /* Usage */ 38 :
        let action$2 = action._0;
        if (/* tag */ typeof action$2 !== "object" && typeof action$2 !== "function") {
          switch (action$2) {
            case /* Open */ 0 :
              const newrecord$26 = Caml_obj.caml_obj_dup(t);
              newrecord$26.usage_form = Mapre_web__Web_usage_model.initial;
              return newrecord$26;
            case /* Close */ 1 :
              const newrecord$27 = Caml_obj.caml_obj_dup(t);
              newrecord$27.usage_form = undefined;
              return newrecord$27;
          }
        }
        const newrecord$28 = Caml_obj.caml_obj_dup(t);
        newrecord$28.usage_form = Stdlib__Option.map((function (p) {
          return Mapre_web__Web_usage_model.update(p, action$2);
        }), t.usage_form);
        return newrecord$28;
      case /* Session_usage */ 39 :
        const newrecord$29 = Caml_obj.caml_obj_dup(t);
        newrecord$29.session_usage = Mapre_web__Web_session_usage_model.update(t.session_usage, action._0);
        return newrecord$29;
      case /* Personal_tokens */ 40 :
        let request_id$5 = action._0;
        if (/* tag */ typeof request_id$5 !== "object" && typeof request_id$5 !== "function") {
          if (request_id$5 === /* Close */ 0) {
            const newrecord$30 = Caml_obj.caml_obj_dup(t);
            newrecord$30.personal_tokens = undefined;
            return newrecord$30;
          }
          
        } else if (request_id$5.TAG === /* Open */ 0) {
          const newrecord$31 = Caml_obj.caml_obj_dup(t);
          newrecord$31.personal_tokens = Mapre_web__Web_personal_tokens_model.initial(request_id$5._0);
          return newrecord$31;
        }
        const newrecord$32 = Caml_obj.caml_obj_dup(t);
        newrecord$32.personal_tokens = Stdlib__Option.map((function (p) {
          return Mapre_web__Web_personal_tokens_model.update(p, request_id$5);
        }), t.personal_tokens);
        return newrecord$32;
      case /* Accounts */ 41 :
        let request_id$6 = action._0;
        if (/* tag */ typeof request_id$6 !== "object" && typeof request_id$6 !== "function") {
          if (request_id$6 === /* Close */ 0) {
            const newrecord$33 = Caml_obj.caml_obj_dup(t);
            newrecord$33.account_form = undefined;
            return newrecord$33;
          }
          
        } else if (request_id$6.TAG === /* Open */ 0) {
          const newrecord$34 = Caml_obj.caml_obj_dup(t);
          newrecord$34.navigation_open = false;
          newrecord$34.account_form = Mapre_web__Web_accounts_model.initial(request_id$6._0);
          return newrecord$34;
        }
        const newrecord$35 = Caml_obj.caml_obj_dup(t);
        newrecord$35.account_form = Stdlib__Option.map((function (form) {
          return Mapre_web__Web_accounts_model.update(form, request_id$6);
        }), t.account_form);
        return newrecord$35;
      case /* Permissions */ 42 :
        const newrecord$36 = Caml_obj.caml_obj_dup(t);
        newrecord$36.permissions = Mapre_web__Web_permissions_model.update(t.permissions, action._0);
        return newrecord$36;
      case /* Messages */ 43 :
        const newrecord$37 = Caml_obj.caml_obj_dup(t);
        newrecord$37.messages = Mapre_web__Web_message_model.update(t.messages, action._0);
        return newrecord$37;
      case /* Attachments */ 44 :
        const action$3 = action._1;
        if (action._0 === /* Initial */ 0) {
          return update_form(t, (function (form) {
            return {
              source: form.source,
              subscription: form.subscription,
              title: form.title,
              prompt: form.prompt,
              attachments: Mapre_web__Web_attachments_model.update(form.attachments, action$3),
              budget: form.budget,
              deadline: form.deadline,
              request_id: form.request_id,
              pending: form.pending
            };
          }));
        }
        const newrecord$38 = Caml_obj.caml_obj_dup(t);
        const init = t.messages;
        newrecord$38.messages = {
          draft: init.draft,
          attachments: Mapre_web__Web_attachments_model.update(t.messages.attachments, action$3),
          control: init.control,
          attempt: init.attempt,
          message: init.message,
          denied: init.denied,
          subscription: init.subscription,
          budget: init.budget,
          continuing_from: init.continuing_from
        };
        return newrecord$38;
      case /* Publication */ 45 :
        const newrecord$39 = Caml_obj.caml_obj_dup(t);
        newrecord$39.publication = Mapre_web__Web_publication_model.update(t.publication, action._0);
        return newrecord$39;
      case /* Checkpoint */ 46 :
        const newrecord$40 = Caml_obj.caml_obj_dup(t);
        newrecord$40.checkpoint = Mapre_web__Web_checkpoint_model.update(t.checkpoint, action._0);
        return newrecord$40;
      case /* Comments */ 47 :
        const newrecord$41 = Caml_obj.caml_obj_dup(t);
        newrecord$41.comments = Mapre_web__Web_comments_model.update(t.comments, action._0);
        return newrecord$41;
      case /* Invitations */ 48 :
        let id$1 = action._0;
        if (/* tag */ typeof id$1 !== "object" && typeof id$1 !== "function") {
          if (id$1 === /* Close */ 0) {
            const newrecord$42 = Caml_obj.caml_obj_dup(t);
            newrecord$42.invitation_form = undefined;
            return newrecord$42;
          }
          
        } else {
          switch (id$1.TAG) {
            case /* Open */ 0 :
              const newrecord$43 = Caml_obj.caml_obj_dup(t);
              newrecord$43.invitation_form = Mapre_web__Web_invitation_model.initial(/* Manage */ 0, id$1._0);
              return newrecord$43;
            case /* Receive */ 1 :
              const newrecord$44 = Caml_obj.caml_obj_dup(t);
              newrecord$44.invitation_form = Mapre_web__Web_invitation_model.initial({
                TAG: /* Recipient */ 0,
                _0: id$1._0
              }, "");
              return newrecord$44;
          }
        }
        const newrecord$45 = Caml_obj.caml_obj_dup(t);
        newrecord$45.invitation_form = Stdlib__Option.map((function (form) {
          return Mapre_web__Web_invitation_model.update(form, id$1);
        }), t.invitation_form);
        return newrecord$45;
      default:
        return t;
    }
  }
}

function pane_opened(param) {
  if (/* tag */ typeof param !== "object" && typeof param !== "function") {
    return false;
  }
  switch (param.TAG) {
    case /* Open_form */ 15 :
    case /* Open_child */ 16 :
    case /* Open_workspace */ 29 :
      return true;
    case /* Project_setup */ 32 :
      let tmp = param._0;
      if (/* tag */ typeof tmp !== "object" && typeof tmp !== "function") {
        return false;
      }
      switch (tmp.TAG) {
        case /* Open */ 0 :
        case /* Rebind */ 1 :
          return true;
        default:
          return false;
      }
    case /* Environment */ 33 :
      let tmp$1 = param._0;
      if (/* tag */ typeof tmp$1 !== "object" && typeof tmp$1 !== "function" || tmp$1.TAG !== /* Open */ 0) {
        return false;
      } else {
        return true;
      }
    case /* Build */ 34 :
      let tmp$2 = param._0;
      if (/* tag */ typeof tmp$2 !== "object" && typeof tmp$2 !== "function" || tmp$2.TAG !== /* Open */ 0) {
        return false;
      } else {
        return true;
      }
    case /* Pulls */ 35 :
      let tmp$3 = param._0;
      if (/* tag */ typeof tmp$3 !== "object" && typeof tmp$3 !== "function" || tmp$3.TAG !== /* Open */ 0) {
        return false;
      } else {
        return true;
      }
    case /* Graph */ 36 :
      let tmp$4 = param._0;
      if (/* tag */ typeof tmp$4 !== "object" && typeof tmp$4 !== "function" || tmp$4.TAG !== /* Open */ 0) {
        return false;
      } else {
        return true;
      }
    case /* Settings */ 37 :
      let tmp$5 = param._0;
      if (/* tag */ typeof tmp$5 !== "object" && typeof tmp$5 !== "function" || tmp$5.TAG !== /* Open */ 0) {
        return false;
      } else {
        return true;
      }
    case /* Usage */ 38 :
      let tmp$6 = param._0;
      if (/* tag */ typeof tmp$6 !== "object" && typeof tmp$6 !== "function" && tmp$6 === /* Open */ 0) {
        return true;
      } else {
        return false;
      }
    case /* Accounts */ 41 :
      let tmp$7 = param._0;
      if (/* tag */ typeof tmp$7 !== "object" && typeof tmp$7 !== "function" || tmp$7.TAG !== /* Open */ 0) {
        return false;
      } else {
        return true;
      }
    case /* Invitations */ 48 :
      let tmp$8 = param._0;
      if (/* tag */ typeof tmp$8 !== "object" && typeof tmp$8 !== "function" || tmp$8.TAG !== /* Open */ 0) {
        return false;
      } else {
        return true;
      }
    default:
      return false;
  }
}

function close_panes(t) {
  const newrecord = Caml_obj.caml_obj_dup(t);
  newrecord.session_panel = undefined;
  newrecord.invitation_form = undefined;
  newrecord.account_form = undefined;
  newrecord.personal_tokens = undefined;
  newrecord.session_usage = Mapre_web__Web_session_usage_model.initial;
  newrecord.usage_form = undefined;
  newrecord.settings_form = undefined;
  newrecord.graph_form = undefined;
  newrecord.pulls_form = undefined;
  newrecord.build_form = undefined;
  newrecord.environment_form = undefined;
  newrecord.project_form = undefined;
  return newrecord;
}

function pane(t) {
  if (t.settings_form !== undefined) {
    return "general";
  }
  if (t.usage_form !== undefined) {
    return "usage";
  }
  if (t.account_form !== undefined) {
    return "accounts";
  }
  if (t.invitation_form === undefined) {
    if (t.project_form !== undefined) {
      return "project";
    } else if (t.environment_form !== undefined) {
      return "environment";
    } else if (t.build_form !== undefined) {
      return "templates";
    } else if (t.pulls_form !== undefined) {
      return "pulls";
    } else if (t.graph_form !== undefined) {
      return "logseq";
    } else {
      return;
    }
  }
  const match = Stdlib__Option.get(t.invitation_form).mode;
  if (/* tag */ typeof match !== "object" && typeof match !== "function") {
    return "members";
  }
  
}

function toggle_navigation(t) {
  if (t.compact) {
    const newrecord = Caml_obj.caml_obj_dup(t);
    newrecord.navigation_open = !t.navigation_open;
    return newrecord;
  }
  const newrecord$1 = Caml_obj.caml_obj_dup(t);
  newrecord$1.sidebar_collapsed = !t.sidebar_collapsed;
  return newrecord$1;
}

function update_chrome(t, session_query) {
  if (/* tag */ typeof session_query !== "object" && typeof session_query !== "function") {
    switch (session_query) {
      case /* Toggle_sidebar_search */ 13 :
        const newrecord = Caml_obj.caml_obj_dup(t);
        newrecord.sidebar_search_open = !t.sidebar_search_open;
        newrecord.session_query = "";
        return newrecord;
      case /* Toggle_sidebar */ 14 :
        return toggle_navigation(t);
      case /* Close_menu */ 15 :
        const newrecord$1 = Caml_obj.caml_obj_dup(t);
        newrecord$1.open_menu = undefined;
        return newrecord$1;
      case /* Close_session_panel */ 16 :
        const newrecord$2 = Caml_obj.caml_obj_dup(t);
        newrecord$2.session_panel = undefined;
        newrecord$2.session_usage = Mapre_web__Web_session_usage_model.initial;
        return newrecord$2;
      case /* Close_settings */ 17 :
        return close_panes(t);
      case /* Escape */ 18 :
        if (t.open_menu === undefined) {
          return close_panes(t);
        }
        const newrecord$3 = Caml_obj.caml_obj_dup(t);
        newrecord$3.open_menu = undefined;
        return newrecord$3;
    }
  } else {
    switch (session_query.TAG) {
      case /* Search_sessions */ 49 :
        const newrecord$4 = Caml_obj.caml_obj_dup(t);
        newrecord$4.session_query = session_query._0;
        return newrecord$4;
      case /* Open_menu */ 50 :
        const newrecord$5 = Caml_obj.caml_obj_dup(t);
        newrecord$5.open_menu = session_query._0;
        return newrecord$5;
      case /* Open_session_panel */ 51 :
        if (!(t.selected !== undefined && !Caml_obj.caml_notequal(t.entry, /* Ready */ 1))) {
          return t;
        }
        const newrecord$6 = Caml_obj.caml_obj_dup(close_panes(t));
        newrecord$6.session_panel = session_query._0;
        newrecord$6.workspace_form = undefined;
        newrecord$6.form = undefined;
        return newrecord$6;
      case /* Toggle_group */ 52 :
        let key = session_query._0;
        if (Mapre_web__Web_timeline.group_expanded(Mapre_web__Web_timeline.live(t.events), t.expanded_groups, t.collapsed_groups, key)) {
          const newrecord$7 = Caml_obj.caml_obj_dup(t);
          newrecord$7.collapsed_groups = Curry._2(Mapre_web__Web_timeline.Ints.add, key, t.collapsed_groups);
          newrecord$7.expanded_groups = Curry._2(Mapre_web__Web_timeline.Ints.remove, key, t.expanded_groups);
          return newrecord$7;
        }
        const newrecord$8 = Caml_obj.caml_obj_dup(t);
        newrecord$8.collapsed_groups = Curry._2(Mapre_web__Web_timeline.Ints.remove, key, t.collapsed_groups);
        newrecord$8.expanded_groups = Curry._2(Mapre_web__Web_timeline.Ints.add, key, t.expanded_groups);
        return newrecord$8;
    }
  }
  if (!pane_opened(session_query)) {
    return update_forms(t, session_query);
  }
  const newrecord$9 = Caml_obj.caml_obj_dup(close_panes(t));
  return update_forms((newrecord$9.navigation_open = false, newrecord$9), session_query);
}

function merge_live(t, incoming) {
  const merged = merge(t.events, incoming);
  const events = t.backlog.expanded ? merged : Mapre_chat__Chat_projection.live(merged);
  let backlog;
  if (Stdlib__List.length(events) < Stdlib__List.length(merged)) {
    const init = t.backlog;
    backlog = {
      before: Stdlib__Option.map((function (e) {
        return e.seq;
      }), Stdlib__List.nth_opt(events, 0)),
      more: true,
      loading: init.loading,
      expanded: init.expanded
    };
  } else {
    backlog = t.backlog;
  }
  const newrecord = Caml_obj.caml_obj_dup(t);
  newrecord.connection = "Live";
  newrecord.backlog = backlog;
  newrecord.events = events;
  return newrecord;
}

function update_events(t, loading) {
  if (/* tag */ typeof loading !== "object" && typeof loading !== "function") {
    return update_chrome(t, loading);
  }
  switch (loading.TAG) {
    case /* Events */ 9 :
      const events = Stdlib__List.filter((function ($$event) {
        return Stdlib__Option.fold(true, (function (before) {
          return $$event.seq >= before;
        }), t.backlog.before);
      }), loading._1);
      const newrecord = Caml_obj.caml_obj_dup(merge_live(t, events));
      newrecord.cursor = loading._0;
      return newrecord;
    case /* Recent */ 10 :
      const newrecord$1 = Caml_obj.caml_obj_dup(t);
      newrecord$1.backlog = {
        before: loading._1,
        more: loading._2,
        loading: false,
        expanded: false
      };
      newrecord$1.cursor = loading._0;
      newrecord$1.events = loading._3;
      return newrecord$1;
    case /* Older */ 11 :
      const newrecord$2 = Caml_obj.caml_obj_dup(t);
      newrecord$2.backlog = {
        before: loading._0,
        more: loading._1,
        loading: false,
        expanded: true
      };
      newrecord$2.events = merge(t.events, loading._2);
      return newrecord$2;
    case /* Older_loading */ 12 :
      const newrecord$3 = Caml_obj.caml_obj_dup(t);
      const init = t.backlog;
      newrecord$3.backlog = {
        before: init.before,
        more: init.more,
        loading: loading._0,
        expanded: init.expanded
      };
      return newrecord$3;
    case /* Detail */ 13 :
      const newrecord$4 = Caml_obj.caml_obj_dup(t);
      newrecord$4.events = merge(t.events, {
        hd: loading._0,
        tl: /* [] */ 0
      });
      return newrecord$4;
    default:
      return update_chrome(t, loading);
  }
}

function update(t, route) {
  if (/* tag */ typeof route !== "object" && typeof route !== "function") {
    if (route === /* Toggle_navigation */ 7) {
      return toggle_navigation(t);
    } else {
      return update_events(t, route);
    }
  }
  switch (route.TAG) {
    case /* Navigate */ 0 :
      let route$1 = route._0;
      const newrecord = Caml_obj.caml_obj_dup(initial);
      newrecord.sidebar_collapsed = t.sidebar_collapsed;
      newrecord.sidebar_search_open = t.sidebar_search_open;
      newrecord.session_query = t.session_query;
      newrecord.current_user = t.current_user;
      newrecord.github_login = t.github_login;
      newrecord.compact = t.compact;
      newrecord.entry = Caml_obj.caml_notequal(t.entry, /* Ready */ 1) ? /* Loading */ 0 : /* Ready */ 1;
      newrecord.collapsed_sessions = Caml_obj.caml_equal(Mapre_web__Web_types.project(route$1), Mapre_web__Web_types.project(t.route)) && Caml_obj.caml_equal(Mapre_web__Web_types.workspace(route$1), Mapre_web__Web_types.workspace(t.route)) ? t.collapsed_sessions : Mapre_web__Web_session_tree.Ids.empty;
      newrecord.sessions = Caml_obj.caml_equal(Mapre_web__Web_types.project(route$1), Mapre_web__Web_types.project(t.route)) && Caml_obj.caml_equal(Mapre_web__Web_types.workspace(route$1), Mapre_web__Web_types.workspace(t.route)) ? t.sessions : /* [] */ 0;
      newrecord.workspaces = t.workspaces;
      newrecord.route = route$1;
      return newrecord;
    case /* Workspaces */ 1 :
      const newrecord$1 = Caml_obj.caml_obj_dup(t);
      newrecord$1.entry = /* Ready */ 1;
      newrecord$1.workspaces = route._0;
      return newrecord$1;
    case /* Projects */ 2 :
      const newrecord$2 = Caml_obj.caml_obj_dup(t);
      newrecord$2.projects = route._0;
      return newrecord$2;
    case /* Sessions */ 3 :
      const newrecord$3 = Caml_obj.caml_obj_dup(t);
      newrecord$3.next_session = route._1;
      newrecord$3.sessions = route._0;
      return newrecord$3;
    case /* Templates */ 4 :
      const newrecord$4 = Caml_obj.caml_obj_dup(t);
      newrecord$4.templates = route._0;
      return newrecord$4;
    case /* Subscriptions */ 5 :
      let incoming = route._0;
      let subscription_cursor = route._1;
      let more = route._2;
      const subscriptions = more ? Stdlib.$at(t.subscriptions, incoming) : incoming;
      const newrecord$5 = Caml_obj.caml_obj_dup(t);
      newrecord$5.messages = Mapre_web__Web_message_model.accounts(t.messages, subscriptions);
      newrecord$5.subscriptions_loading = false;
      newrecord$5.subscription_cursor = subscription_cursor;
      newrecord$5.subscriptions = subscriptions;
      return update_form(newrecord$5, (function (f) {
        const match = f.subscription;
        if (match !== undefined) {
          return f;
        } else {
          return {
            source: f.source,
            subscription: Stdlib__List.find_opt((function (s) {
              if (s.ownership === "personal") {
                return Mapre_web__Web_subscription.selectable(s);
              } else {
                return false;
              }
            }), subscriptions),
            title: f.title,
            prompt: f.prompt,
            attachments: f.attachments,
            budget: f.budget,
            deadline: f.deadline,
            request_id: f.request_id,
            pending: f.pending
          };
        }
      }));
    case /* Subscriptions_loading */ 7 :
      const newrecord$6 = Caml_obj.caml_obj_dup(t);
      newrecord$6.subscriptions_loading = route._0;
      return newrecord$6;
    case /* Selected */ 8 :
      const selected = route._0;
      const newrecord$7 = Caml_obj.caml_obj_dup(t);
      newrecord$7.selected = selected;
      newrecord$7.sessions = Mapre_web__Web_session_tree.merge(t.sessions, {
        hd: selected,
        tl: /* [] */ 0
      });
      return newrecord$7;
    case /* Commands */ 14 :
      const commands = route._0;
      const newrecord$8 = Caml_obj.caml_obj_dup(t);
      newrecord$8.messages = Mapre_web__Web_message_model.update(t.messages, {
        TAG: /* Reconcile */ 7,
        _0: Stdlib__List.map((function (c) {
          return c.id;
        }), commands)
      });
      newrecord$8.commands = commands;
      return newrecord$8;
    case /* Connection */ 22 :
      const newrecord$9 = Caml_obj.caml_obj_dup(t);
      newrecord$9.connection = route._0;
      return newrecord$9;
    case /* Lock */ 23 :
      const newrecord$10 = Caml_obj.caml_obj_dup(initial);
      newrecord$10.github_login = t.github_login;
      newrecord$10.compact = t.compact;
      newrecord$10.entry = {
        TAG: /* Locked */ 0,
        _0: route._0
      };
      newrecord$10.notice = route._1;
      newrecord$10.route = t.route;
      return newrecord$10;
    case /* Compact */ 25 :
      const newrecord$11 = Caml_obj.caml_obj_dup(t);
      newrecord$11.compact = route._0;
      return newrecord$11;
    case /* Auth_config */ 26 :
      const newrecord$12 = Caml_obj.caml_obj_dup(t);
      newrecord$12.github_login = route._0;
      return newrecord$12;
    case /* Signed_in */ 27 :
      const newrecord$13 = Caml_obj.caml_obj_dup(t);
      newrecord$13.current_user = route._0;
      return newrecord$13;
    case /* Expand_session */ 28 :
      const id = route._0;
      const newrecord$14 = Caml_obj.caml_obj_dup(t);
      newrecord$14.collapsed_sessions = route._1 ? Curry._2(Mapre_web__Web_session_tree.Ids.remove, id, t.collapsed_sessions) : Curry._2(Mapre_web__Web_session_tree.Ids.add, id, t.collapsed_sessions);
      return newrecord$14;
    default:
      return update_events(t, route);
  }
}

function can_create(t) {
  const id = Mapre_web__Web_types.workspace(t.route);
  if (id !== undefined) {
    return Stdlib__List.exists((function (w) {
      if (w.id === id) {
        return Mapre_core__Access.allows(w.role, /* Execute */ 2);
      } else {
        return false;
      }
    }), t.workspaces);
  } else {
    return false;
  }
}

function can_submit(t) {
  const match = t.form;
  const match$1 = t.templates;
  if (match !== undefined && (match.source !== undefined || Caml_obj.caml_notequal(match$1, /* [] */ 0)) && !match.pending && !t.subscriptions_loading && Stdlib__String.trim(match.title) !== "" && (Stdlib__String.trim(match.prompt) !== "" || Caml_obj.caml_notequal(match.attachments.items, /* [] */ 0)) && Mapre_web__Web_attachments_model.ready(match.attachments)) {
    return Stdlib__Option.fold(false, (function (chosen) {
      return Stdlib__List.exists((function (s) {
        if (s.id === chosen.id && s.authorization_version === chosen.authorization_version) {
          return Mapre_web__Web_subscription.selectable(s);
        } else {
          return false;
        }
      }), t.subscriptions);
    }), match.subscription);
  } else {
    return false;
  }
}

function can_create_workspace(t) {
  const f = t.workspace_form;
  if (f !== undefined && !Caml_obj.caml_notequal(t.entry, /* Ready */ 1) && t.current_user !== undefined && !f.pending && Stdlib__String.trim(f.name) !== "") {
    return Stdlib__String.trim(f.timezone) !== "";
  } else {
    return false;
  }
}

function can_manage_project(t) {
  if (Caml_obj.caml_notequal(t.entry, /* Ready */ 1)) {
    return false;
  } else {
    return Stdlib__List.exists((function (w) {
      if (Caml_obj.caml_equal(w.id, Mapre_web__Web_types.workspace(t.route))) {
        return Mapre_core__Access.allows(w.role, /* Manage_project */ 3);
      } else {
        return false;
      }
    }), t.workspaces);
  }
}

function can_edit_environment(t) {
  if (!Caml_obj.caml_notequal(t.entry, /* Ready */ 1) && Stdlib__List.exists((function (p) {
      return Caml_obj.caml_equal(p.id, Mapre_web__Web_types.project(t.route));
    }), t.projects)) {
    return Stdlib__List.exists((function (w) {
      if (Caml_obj.caml_equal(w.id, Mapre_web__Web_types.workspace(t.route))) {
        return Mapre_core__Access.allows(w.role, /* Edit_environment */ 1);
      } else {
        return false;
      }
    }), t.workspaces);
  } else {
    return false;
  }
}

function can_manage_members(t) {
  const id = Mapre_web__Web_types.workspace(t.route);
  if (id !== undefined && !Caml_obj.caml_notequal(t.entry, /* Ready */ 1)) {
    return Stdlib__List.exists((function (w) {
      if (w.id === id) {
        return Mapre_core__Access.allows(w.role, /* Manage_members */ 4);
      } else {
        return false;
      }
    }), t.workspaces);
  } else {
    return false;
  }
}

const Ints = Mapre_web__Web_timeline.Ints;

export {
  Ints,
  initial,
  locked,
  update,
  can_create,
  can_submit,
  can_create_workspace,
  can_manage_project,
  can_edit_environment,
  can_manage_members,
  pane,
  pane_opened,
}
/* Events_by_seq Not a pure module */
